module.exports = __webpack_public_path__ + "img/rightcard.04700435.png";